import * as actions from '../../actions/actionTypes';

const initialState = {
  reservedList: [],
};

export default function channelMapReservation(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CHANNEL_MAPPING_RESERVATION:
      return action.payload;
    default:
      return state;
  }
}
